<template>
  <div class="main-content-container container-fluid px-4">
    <div class="d-flex page-header row no-gutters py-4">
      <div class="col-12 col-md-8 text-center text-sm-left mb-sm-0 mb-3">
        <span class="text-uppercase page-subtitle">Mes demandes</span>
        <h3 class="page-title">{{ $t("dailyReport.title") }}</h3>
      </div>
    </div>

    <!-- page header -->
    <!-- @FixMe: call it through shared components  -->
    <div>
      <VueCal
        :selected-date="picker"
        :time-from="0 * 60"
        :time-to="24 * 60"
        v-if="isMobile()"
        :disable-views="['years', 'year', 'month', 'week']"
        :events="events"
        class="vuecal--full-height-delete"
        locale="fr"
        @event-title-change="eventCreateAndEditHandler"
        @event-delete="eventDeleteHandler"
        @event-duration-change="eventResizing"
        :readOnly="false"
      >
        <template v-slot:weekday-heading="{ heading, view }">
          <div v-if="checkDate(heading)">
            <div style="width: 100%; height: 100%" class="back-next-btn">
              <button
                class="back-btn-submit"
                @click="editOrCreate(heading, view)"
              >
                {{
                  totalTimePerDay(heading, view) === "00h 00m"
                    ? "Créer"
                    : "Editer"
                }}
              </button>
            </div>
          </div>
        </template>
        <template v-slot:title="{ title }">
          <v-dialog v-model="dialog" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black lighten-2"
                icon
                text
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>event</v-icon>
              </v-btn>
            </template>

            <v-date-picker
              locale="fr"
              color="#4f78e2"
              v-model="picker"
            ></v-date-picker>
          </v-dialog>
          {{ title }}
        </template>
      </VueCal>
      <VueCal
        :selected-date="picker"
        :time-from="timeFrom * 60"
        :time-to="24 * 60"
        v-else
        :disable-views="['years', 'year', 'month']"
        :events="events"
        class="vuecal--full-height-delete"
        locale="fr"
        @event-title-change="eventCreateAndEditHandler"
        @event-delete="eventDeleteHandler"
        @event-duration-change="eventResizing"
        :readOnly="false"
      >
        <template v-slot:weekday-heading="{ heading, view }">
          <div v-if="checkDate(heading)">
            <div
              style="width: 100%; height: 100%"
              class="back-next-btn float-left float-sm-right"
            >
              <button
                class="back-btn-submit"
                @click="editOrCreate(heading, view)"
              >
                {{
                  totalTimePerDay(heading, view) === "00h 00m"
                    ? "Créer"
                    : "Editer"
                }}
              </button>
            </div>
          </div>
        </template>
        <template v-slot:title="{ title }">
          <v-dialog v-model="dialog" max-width="290">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="black lighten-2"
                icon
                text
                dark
                v-bind="attrs"
                v-on="on"
              >
                <v-icon>event</v-icon>
              </v-btn>
            </template>

            <v-date-picker
              locale="fr"
              color="#4f78e2"
              v-model="picker"
            ></v-date-picker>
          </v-dialog>
          {{ title }}
        </template>
      </VueCal>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import groups from "@/data/groups/Groups";
import { fr } from "vuejs-datepicker/dist/locale";
import VueCal from "vue-cal-custom";
import "vue-cal-custom/dist/vuecal.css";
import "vue-cal-custom/dist/i18n/fr.js";
import "./calendar.scss";
import ErrorsHelper from "../../helper/ErrorsHelper";

export default {
  mounted() {
    this.fetchReports();
  },
  created() {
    window.addEventListener("wheel", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("wheel", this.handleScroll);
  },
  data() {
    return {
      reportCard: {
        dateOfReport: "",
        dateOfSubmission: new Date(),
        totalTime: "0h 0min",
        tasks: [],
      },
      timeFrom: 8,
      dialog: false,
      picker: this.selectedDate,
      reportCards: [],
      events: [],
      reports: [],
      requiredFields: ["title", "startHour", "endHour", "duration"],
      errors: {},
      filteredReports: [],
      pendingReports: [],
      filterPendingReports: [],
      groupName: "",
      userName: "",
      groups,
      structure: "",
      dateFor: "",
      dateAdded: "",
      type: ["day", "week"],
      userIds: [],
      pendingStructure: "",
      pendingReportFor: "",
      pendingUserName: "",
      fr,
      selectedUsersReports: [],
      myReports: [],
    };
  },
  components: { VueCal },
  computed: {
    user() {
      return this.$store.state.user.informations;
    },
    selectedDate() {
      const now = Date.now();
      const date = new Date(now);
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    maxDate() {
      return new Date();
    },
  },

  methods: {
    handleScroll(event) {
      if (event.deltaY < 0) {
        if (this.timeFrom > 0) this.timeFrom -= 1;
      } else if (event.deltaY > 0) {
        if (this.timeFrom < 8) this.timeFrom += 1;
      }
    },
    goNext() {
      const { tasks } = this.reportCard;

      const dates = tasks.map((task) => ({
        hour: Number(task.startHour.hour),
        mint: Number(task.startHour.mint),
      }));

      dates.sort((a, b) => {
        if (a.hour < b.hour) {
          return -1;
        }
        if (a.hour > b.hour) {
          return 1;
        }
        if (a.hour === b.hour && a.mint < b.mint) {
          return -1;
        }
        if (a.hour === b.hour && a.mint > b.mint) {
          return 1;
        }
        if (a.hour === b.hour && a.mint === b.mint) {
          return 0;
        }
      });
      const min = dates[0];
      const date = new Date(this.reportCard.dateOfReport);

      date.setHours(min.hour);
      date.setMinutes(min.mint);
      this.reportCard.dateOfReport = date.toISOString();
      const duration = { hour: "0", mint: "0" };
      tasks.forEach((task) => {
        const { hour, mint } = task.duration;
        duration.hour = (Number(duration.hour) + Number(hour)).toString();
        duration.mint = (Number(duration.mint) + Number(mint)).toString();
      });
      this.reportCard.totalTime = `${duration.hour}h ${duration.mint}min`;

      if (this.validateReportCard()) {
        this.$store.dispatch("setReportCard", this.reportCard);
        this.$store.dispatch("setDateOfReport", this.reportCard.dateOfReport);
        this.$router.push("/reportCard");
      }
    },
    totalTimePerDay(heading, view) {
      const { date } = heading;
      const headingDate = new Date(date);
      const { events } = view;
      const todaysEvents = events.filter((event) => {
        const { start } = event;
        const startDate = new Date(start);
        return (
          headingDate.getFullYear() === startDate.getFullYear() &&
          headingDate.getMonth() === startDate.getMonth() &&
          headingDate.getDate() === startDate.getDate()
        );
      });
      const totalTime = { hours: 0, minutes: 0 };

      todaysEvents.forEach((event) => {
        const { start, end } = event;
        const startDate = new Date(start);
        const endDate = new Date(end);
        totalTime.hours += endDate.getHours() - startDate.getHours();
        totalTime.minutes += Math.abs(
          endDate.getMinutes() - startDate.getMinutes()
        );
      });
      totalTime.hours += Math.floor(totalTime.minutes / 60);
      totalTime.minutes = totalTime.minutes % 60;
      return `${
        totalTime.hours < 10 ? `0${totalTime.hours}` : totalTime.hours
      }h ${
        totalTime.minutes < 10 ? `0${totalTime.minutes}` : totalTime.minutes
      }m`;
    },
    editOrCreate(heading, view) {
      const createValue =
        this.totalTimePerDay(heading, view) === "00h 00m" ? 1 : 0;
      if (createValue === 1) {
        this.$store.dispatch("setReportCard", null);
        this.$store.dispatch("setDateOfReport", heading.date);
        this.$router.push(`/reportForm/${createValue}`);
      } else {
        const headingDate = new Date(heading.date);
        const report = this.reportCards.find((item) => {
          const date = new Date(item.dateOfReport);
          return (
            date.getFullYear() === headingDate.getFullYear() &&
            date.getMonth() === headingDate.getMonth() &&
            date.getDate() === headingDate.getDate()
          );
        });

        this.$store.dispatch("setReportCard", report);
        this.$store.dispatch("setDateOfReport", heading.date);
        this.$router.push(`/reportForm/${createValue}`);
      }
    },
    validateReportCard() {
      const results = this.reportCards.map((reportCard) => {
        let i = 0;
        const valid = [];
        this.errors = {};
        reportCard.tasks.forEach((task) => {
          task.id = i;
          valid[i] = ErrorsHelper.checkErrors(
            this.requiredFields,
            task,
            this.errors
          );
          i++;
        });
        return !valid.includes(false);
      });
      return results.find((res) => res === false) === undefined;
    },
    fetchReports() {
      this.$services.dailyReport
        .getReportsByUserRef(this.user.reference)
        .then((res) => {
          this.reports = res.data;

          this.filteredReports = this.reports;
        });
    },

    selectApi() {
      this.fetchReports();
    },
    eventCreateAndEditHandler({ event, oldTitle }) {
      const { start, end, title } = event;
      this.reportCard.dateOfReport = start;
      const startDate = new Date(start);
      const endDate = new Date(end);
      const currentDate = new Date();

      const totalTime = "";

      const task = this.reportCard.tasks.find(
        (task) =>
          task.startHour.hour === startDate.getHours().toString() &&
          task.startHour.mint === startDate.getMinutes().toString() &&
          task.endHour.hour === endDate.getHours().toString() &&
          task.endHour.mint === endDate.getMinutes().toString() &&
          oldTitle === task.title
      );

      if (task === undefined) {
        const duration = {
          hour: `${Math.abs(endDate.getHours() - startDate.getHours())}`,
          mint: `${Math.abs(endDate.getMinutes() - startDate.getMinutes())}`,
        };
        this.reportCard.tasks.push({
          startHour: {
            hour: `${startDate.getHours()}`,
            mint: `${startDate.getMinutes()}`,
          },
          endHour: {
            hour: `${endDate.getHours()}`,
            mint: `${endDate.getMinutes()}`,
          },
          title,
          duration: duration,
        });
        this.events.push({
          start: `${startDate.getFullYear()}-${
            startDate.getMonth() + 1
          }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}`,
          end: `${endDate.getFullYear()}-${
            endDate.getMonth() + 1
          }-${endDate.getDate()} ${endDate.getHours()}:${endDate.getMinutes()}`,
          content: title,
          class: "blue-event",
          title: `${
            Number(duration.hour) < 10
              ? `0${Number(duration.hour)}`
              : Number(duration.hour)
          }h ${
            Number(duration.mint) < 10
              ? `0${Number(duration.mint)}`
              : Number(duration.mint)
          }m`,
        });
      } else {
        task.title = title;
      }
    },
    eventDeleteHandler(event) {
      const { start, end, title } = event;

      const startDate = new Date(start);
      const endDate = new Date(end);
      const report = this.reportCards.find((item) => {
        const date = new Date(item.dateOfReport);
        return (
          date.getFullYear() === startDate.getFullYear() &&
          date.getMonth() === startDate.getMonth() &&
          date.getDate() === startDate.getDate()
        );
      });
      report.tasks = report.tasks.filter(
        (task) =>
          !(
            task.startHour.hour === startDate.getHours().toString() &&
            task.startHour.mint === startDate.getMinutes().toString() &&
            task.endHour.hour === endDate.getHours().toString() &&
            task.endHour.mint === endDate.getMinutes().toString() &&
            title === task.title
          )
      );
      if (report.tasks.length === 0) {
        this.reportCards = this.reportCards.filter((item) => {
          const date = new Date(item.dateOfReport);
          return !(
            date.getFullYear() === startDate.getFullYear() &&
            date.getMonth() === startDate.getMonth() &&
            date.getDate() === startDate.getDate()
          );
        });
      }
    },
    changeTask(event, task) {
      const { end } = event;
      const endDate = new Date(end);

      task.endHour.hour = endDate.getHours().toString();
      task.endHour.mint = endDate.getMinutes().toString();
    },
    eventResizing({ event, oldDate, originalEvent }) {
      const { start, end, title } = originalEvent;

      const startDate = new Date(start);
      const endDate = new Date(end);
      const report = this.reportCards.find((item) => {
        const date = new Date(item.dateOfReport);
        return (
          date.getFullYear() === startDate.getFullYear() &&
          date.getMonth() === startDate.getMonth() &&
          date.getDate() === startDate.getDate()
        );
      });
      const task = report.tasks.find(
        (task) =>
          task.startHour.hour === startDate.getHours().toString() &&
          task.startHour.mint === startDate.getMinutes().toString() &&
          task.endHour.hour === endDate.getHours().toString() &&
          task.endHour.mint === endDate.getMinutes().toString()
      );
      this.changeTask(event, task);
    },
    isMobile() {
      var check = false;
      (function (a) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        )
          check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    },
    checkDate(heading) {
      const { date } = heading;
      const dateTime = new Date(date).getTime();
      const todayTime = new Date().getTime();

      return dateTime > todayTime ? false : true;
    },
  },
  watch: {
    reports() {
      const userRef = this.$store.state.user.informations.reference;
      this.myReports = this.reports.filter(
        (item) => userRef === item.userInfo.reference
      );
      const reportCards = this.myReports.map((report) => report.report);
      this.reportCards.push(...reportCards);
    },
    myReports() {
      const eventsPerReport = this.myReports.map((report) => {
        const date = report.report.dateOfReport;
        const tasks = report.report.tasks ? report.report.tasks : [];
        const d = new Date(report.report.dateOfReport);
        const eventsPerTask = tasks.map((task) => {
          const { startHour, endHour } = task;
          const start_hour = Number(startHour.hour);
          const end_hour = Number(endHour.hour);

          const start_mint = Number(startHour.mint);
          const end_mint = Number(endHour.mint);
          d.setHours(start_hour);
          d.setMinutes(start_mint);
          const startDate = new Date(d.getTime());
          d.setHours(end_hour);
          d.setMinutes(end_mint);
          const endDate = new Date(d.getTime());
          const duration = {
            hour: `${Math.abs(endDate.getHours() - startDate.getHours())}`,
            mint: `${Math.abs(endDate.getMinutes() - startDate.getMinutes())}`,
          };

          return {
            start: `${startDate.getFullYear()}-${
              startDate.getMonth() + 1
            }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}`,
            end: `${endDate.getFullYear()}-${
              endDate.getMonth() + 1
            }-${endDate.getDate()} ${endDate.getHours()}:${endDate.getMinutes()}`,

            content: task.title,
            class: "blue-event",
            title: `${
              Number(duration.hour) < 10
                ? `0${Number(duration.hour)}`
                : Number(duration.hour)
            }h ${
              Number(duration.mint) < 10
                ? `0${Number(duration.mint)}`
                : Number(duration.mint)
            }m`,
          };
        });
        return eventsPerTask;
      });
      let events = [];
      eventsPerReport.forEach((event) => {
        events = [...events, ...event];
      });

      this.events = events;
    },
    type: [
      {
        handler: "selectApi",
      },
    ],
  },
};
</script>

<style lang="scss" scoped>
.grid-main {
  display: grid;
  grid-template-columns: 60% 40%;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 100%;
  }
}
.grid-iner {
  display: grid;
  grid-template-columns: 51% 110px;
  grid-gap: 0px;
  @media (min-width: 320px) and (max-width: 600px) {
    grid-template-columns: 50% 50%;
    grid-gap: 5px;
  }
}

.main-heading {
  object-fit: contain;
  font-size: 30px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.34;
  letter-spacing: normal;
  text-align: left;
  color: #212529;
  font-family: "SF-Pro-Text";
}

.only-sm-mobile {
  display: none;
}
@media screen and (min-width: 320px) and (max-width: 1196px) {
  .only-desk-top {
    display: none;
  }
  .only-sm-mobile {
    display: block;
    .apply {
      float: left;
    }
  }
}

.form-control {
  background-color: #fff !important;
}
.form-field-style-5 {
  width: 131px;

  .user-btn {
    background-color: #e0e3ed;
    width: 100%;
    height: 35px;
    border: none;
    border-radius: 50px;
    color: #9b9fb7;
    font-family: "SF-Pro-Text";
    font-weight: 600;
    &:focus {
      outline: none;
    }
  }
  .selected-user-btn {
    background-color: #cedaf8;
    width: 100%;
    height: 35px;
    border: none;
    border-radius: 50px;
    color: #4f78e1;
    font-family: "SF-Pro-Text";
    font-weight: 600;
    &:focus {
      outline: none;
    }
  }
}
.users-list {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
}
</style>
